import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  Home,
  TremsCondition,
  PrivacyPolicy,
  CommunityGuide,
  Intellectual,
  CSAEPolicy,
  Login,
  DeleteAccount,
} from "./Pages";
import { Footer } from "./Components";
import BrandedPolicy from "./Pages/BrandedPolicy";
import CookiesPolicy from "./Pages/CookiesPolicy";

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/terms-and-conditions" element={<TremsCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/community-guidelines" element={<CommunityGuide />} />
        <Route
          path="/intellectual-property-policy"
          element={<Intellectual />}
        />
        <Route path="/branded-content-policy" element={<BrandedPolicy />} />
        <Route path="/cookies-policy" element={<CookiesPolicy />} />
        <Route path="/child-safety-standards" element={<CSAEPolicy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
